import type {Expand} from '../types';

import {courseExpandCommon} from '../course';
import {userExpandCommon} from '../user';

export const taskExpandCommon: Expand = {
  task: [
    ['course_id', null, courseExpandCommon],
    ['user_id', {name: 'Client not found'}, userExpandCommon],
    ['coach_ids->coaches', {name: 'User not found'}, userExpandCommon],
    'attachment_ids',
    'coach_attachment_ids->coach_attachments',
  ],
};

export const coachTaskExpandCommon: Expand = {
  coach_task: [
    'base_task_id->base_task',
    ['course_id', null, courseExpandCommon],
    ['coach_ids->coaches', {name: 'User not found'}, userExpandCommon],
    'coach_attachment_ids->coach_attachments',
  ],
};
